import * as React from 'react';
import { OTPInput, OTPInputContext } from 'input-otp';

import { cn } from '@/lib/utils';

const InputOTP = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<typeof OTPInput> & { containerClassName?: string }
>(({ className, containerClassName, ...props }, ref) => (
  <OTPInput
    ref={ref}
    data-slot="input-otp"
    containerClassName={cn(
      'tw:flex tw:items-center tw:gap-2 tw:has-disabled:opacity-50',
      containerClassName
    )}
    className={cn('tw:disabled:cursor-not-allowed', className)}
    {...props}
  />
));
InputOTP.displayName = 'InputOTP';

function InputOTPGroup({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="input-otp-group"
      className={cn('tw:flex tw:items-center tw:gap-2', className)}
      {...props}
    />
  );
}

function InputOTPSlot({
  index,
  className,
  ...props
}: React.ComponentProps<'div'> & {
  index: number;
}) {
  const inputOTPContext = React.useContext(OTPInputContext);
  const { char, hasFakeCaret, isActive } = inputOTPContext?.slots[index] ?? {};

  return (
    <div
      data-slot="input-otp-slot"
      data-active={isActive}
      className={cn(
        'tw:relative tw:flex tw:h-14 tw:w-12 tw:items-center tw:justify-center tw:rounded-md tw:border tw:border-gray-300 tw:bg-white tw:text-2xl tw:transition-all tw:outline-none tw:aria-invalid:border-destructive tw:data-[active=true]:z-10 tw:data-[active=true]:border-primary tw:data-[active=true]:ring-2 tw:data-[active=true]:ring-primary/30 tw:data-[active=true]:aria-invalid:border-destructive',
        className
      )}
      {...props}
    >
      {char}
      {hasFakeCaret && (
        <div className="tw:pointer-events-none tw:absolute tw:inset-0 tw:flex tw:items-center tw:justify-center">
          <div className="tw:h-7 tw:w-px tw:animate-pulse tw:bg-gray-700" />
        </div>
      )}
    </div>
  );
}

export { InputOTP, InputOTPGroup, InputOTPSlot };
